
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Слой_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0","y":"0","viewBox":"0 0 79.5 78.5","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"SVGID_1_","d":"M0 0h79.5v78.5H0z"}})]),_c('clipPath',{attrs:{"id":"SVGID_2_"}},[_c('use',{attrs:{"xlink:href":"#SVGID_1_","overflow":"visible"}})]),_c('path',{staticClass:"st0",attrs:{"d":"M58.6 78.5H12.4C5.5 78.5 0 73 0 66.1V19.9C0 13 5.5 7.5 12.4 7.5h23.9c1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5H12.4c-3 0-5.4 2.4-5.4 5.4v46.3c0 3 2.4 5.4 5.4 5.4h46.3c3 0 5.4-2.4 5.4-5.4V42.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5v23.6C71 73 65.5 78.5 58.6 78.5"}}),_c('path',{attrs:{"d":"M35 48c-.9 0-1.8-.3-2.5-1-1.4-1.4-1.4-3.6 0-4.9L73 1.5c1.4-1.4 3.6-1.4 4.9 0 1.4 1.4 1.4 3.6 0 4.9L37.5 47c-.7.7-1.6 1-2.5 1","clip-path":"url(#SVGID_2_)","fill":"#411795"}}),_c('path',{attrs:{"d":"M35 48c-.9 0-1.8-.3-2.5-1-1.4-1.4-1.4-3.6 0-4.9L73 1.5c1.4-1.4 3.6-1.4 4.9 0 1.4 1.4 1.4 3.6 0 4.9L37.5 47c-.7.7-1.6 1-2.5 1z","clip-path":"url(#SVGID_2_)","fill":"none","stroke":"#5933ad","stroke-miterlimit":"10"}}),_c('path',{staticClass:"st0",attrs:{"d":"M75.5 35.5c-1.9 0-3.5-1.6-3.5-3.5V7.5H47.5C45.6 7.5 44 5.9 44 4S45.6.5 47.5.5h28C77.4.5 79 2.1 79 4v28c0 1.9-1.6 3.5-3.5 3.5"}})])
          )
        }
      }
    